module.exports = __webpack_public_path__ + "static/media/enterprise1.e01a53a9.png";